/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ reason: NonNullable<unknown>, signal: NonNullable<unknown> }} Automation_Failure_Notification_BodyInputs */

const en_automation_failure_notification_body = /** @type {(inputs: Automation_Failure_Notification_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Automation failed (${i?.reason}) for signal ${i?.signal}.`)
};

const pt_br2_automation_failure_notification_body = /** @type {(inputs: Automation_Failure_Notification_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A automação falhou (${i?.reason}) para o sinal ${i?.signal}.`)
};

/**
* | output |
* | --- |
* | "Automation failed ({reason}) for signal {signal}." |
*
* @param {Automation_Failure_Notification_BodyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_failure_notification_body = /** @type {((inputs: Automation_Failure_Notification_BodyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Failure_Notification_BodyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_failure_notification_body(inputs)
	return pt_br2_automation_failure_notification_body(inputs)
});